import React from 'react';
import { ChevronLeft, ChevronRight, Play } from 'lucide-react';
import { ASSETS } from '../../../lib/assets';
export function AboutScreen({
  onBack,
  onNext
}: {
  onBack: () => void;
  onNext: () => void;
}) {
  return <section className="flex h-full flex-col px-4 pb-2 pt-2 text-[#115276]" data-id="element-32" data-mp="13jvbk0u4vf3w">
      <div className="flex items-center justify-between" data-id="element-33" data-mp="18jhyj1zrk9pw">
        <RoundButton label="Back" onClick={onBack} data-id="element-34" data-mp="18m46v3uhat96"><ChevronLeft className="h-3.5 w-3.5" data-id="element-35" data-mp="tulh4ebthkcm" />Back</RoundButton>
        <RoundButton label="Next" onClick={onNext} data-id="element-36" data-mp="ttafak1xmmo5">Next<ChevronRight className="h-3.5 w-3.5" data-id="element-37" data-mp="ym3mrfosc93x" /></RoundButton>
      </div>
      <div className="mt-4 flex justify-center gap-1" aria-label="Illustration of children learning together" data-id="element-38" data-mp="kuoyoug0thq0">
        {[ASSETS.self, ASSETS.society, ASSETS.ecology].map((image, index) => <img key={image} src={image} alt="" className={`h-20 w-20 object-contain ${index === 1 ? '-mt-2' : ''}`} data-id="element-39" data-mp="oto0452jmwcp" data-mpi={index} />)}
      </div>
      <h1 className="mt-2 text-center font-display text-xl font-extrabold tracking-[0.24em]" data-id="element-40" data-mp="fvvj8wh6bgn7">ABOUT RANGEET</h1>
      <blockquote className="mt-3 text-center text-xs font-semibold italic leading-relaxed" data-id="element-41" data-mp="2xvmm2bxp3l5q">
        “Human relationships are at the core of learning. Through songs & playful activities, Rangeet flexes our social muscles and prepares children to be tomorrow’s carers, thinkers & citizens.”
      </blockquote>
      <p className="mt-1 text-center text-[9px] font-semibold" data-id="element-42" data-mp="31z2ib75urjhw">Kathy Hirsh-Pasek, Senior Fellow, Brookings</p>
      <button onClick={onNext} className="relative mt-3 overflow-hidden rounded-sm border-2 border-white shadow-md" data-id="element-43" data-mp="2e9870u16m2zr">
        <img src={ASSETS.mobileBg} alt="Rangeet classroom video preview" className="h-24 w-full object-cover opacity-75" data-id="element-44" data-mp="2a8o8pn4vgtc1" />
        <span className="absolute inset-0 grid place-items-center" data-id="element-45" data-mp="2j7i1t3izv1ku"><span className="grid h-10 w-10 place-items-center rounded-full bg-[#f64c4c] text-white shadow" data-id="element-46" data-mp="2j6q7rx51pbwo"><Play className="ml-0.5 h-5 w-5 fill-white" data-id="element-47" data-mp="1vgmd4f9u4mht" /></span></span>
      </button>
      <p className="mt-auto pb-1 text-center text-[10px] font-semibold" data-id="element-48" data-mp="1qjm4pxpij7nj">A playful world of learning, empathy and possibility.</p>
    </section>;
}
function RoundButton({
  label,
  onClick,
  children
}: {
  label: string;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return <button aria-label={label} onClick={onClick} className="flex items-center gap-0.5 rounded-full bg-[#5b5268]/85 px-2 py-1 text-[10px] text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-49" data-mp="45ra2b86yy7y">{children}</button>;
}